import { AllTokens } from "gql/graphql";

export const JMIX_REPORTS_PAGE_SECURITY_TOKENS = [
  AllTokens.AnalyticsReportsTest,
  AllTokens.AnalyticsReportsAbsenceregister,
  AllTokens.AnalyticsReportsVacationbalance,
];
